<template>
  <div class="ui middle aligned center aligned grid" id="login">
    <div class="column">
      <h2 class="ui olive header">
        <div class="content">
          <div class="ui image">
            <img src="../assets/odins-logo-big.png">
          </div>
        </div>
      </h2>
      <form class="ui large form" autocomplete="on" v-bind:class="{'error': errors}" v-on:submit.prevent>
        <div class="">
          <div class="field">
            <div class="ui left icon input">
              <i class="user icon"></i>
              <input type="text" name="email" :placeholder="$t('views.login.email')" v-model="input.username" v-on:keydown.enter.prevent />
            </div>
          </div>
          <div class="field">
            <div class="ui left icon input">
              <i class="lock icon"></i>
              <input
                type="password"
                name="password"
                :placeholder="$t('views.login.password')"
                v-model="input.password"
                v-on:keydown.enter.prevent
              />
            </div>
          </div>
          <div class="ui fluid large olive button" v-on:click="login()">{{$t("views.login.login")}}</div>
          <div id="languages" class="field">
            <a href="/">
              <img src="../assets/spain.png">
            </a>
            <a href="/?lang=en_GB">
              <img src="../assets/uk.png">
            </a>
          </div>
        </div>
        <div class="ui error message">
          <ul class="list">
          </ul>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import EventBus from '../utils/event-bus';
import { Config } from '../config';

export default {
  name: 'Login',
  components: {},
  data () {
    return {
      config: Config,
      errors: false,
      input: {
        username: '',
        password: ''
      },
      language: 'es_ES'
    };
  },
  methods: {
    showErrors (e) {
      this.errors = e;
    },
    login () {
      // launch validation
      if ($('.ui.form').form('validate form')) {
        this.$store.dispatch('login', {
          login: this.input.username,
          password: this.input.password,
          language: this.language
        });
      }
    }
  },
  created: function () {
    this.language = location.search.split('=')[1];
    if (!this.language) {
      this.language = 'es_ES';
    }
    this.$i18n.locale = this.language;
  },
  mounted: function () {
    // { error: error }
    EventBus.$on('loginError', (e) => {
      if (e.error.response.status === 403) {
        $('.ui.form').form('add errors', [this.$i18n.t('views.login.clave_incorrecta')]);
      } else {
        $('.ui.form').form('add errors', [this.$i18n.t('views.login.error_conexion')]);
      }
    });
    EventBus.$on('loginOk', (e) => {
      this.$router.replace({ name: 'home', force: true });
      window.location.reload(true);
    });

    $('.ui.form').form({
      fields: {
        email: {
          identifier: 'email',
          rules: [
            {
              type: 'empty',
              prompt: this.$i18n.t('views.login.enter_email')
            }
          ]
        },
        password: {
          identifier: 'password',
          rules: [
            {
              type: 'empty',
              prompt: this.$i18n.t('views.login.enter_password')
            }
          ]
        }
      },
      onSuccess: (event, fields) => {
        // esto es para cuando se hace login con la tecla intro en el formulario
        if (event && event.type === 'submit') {
          event.preventDefault();
          this.$store.dispatch('login', {
            login: this.input.username,
            password: this.input.password,
            language: this.language
          });
        }
      }
    });
  }
};
</script>

<style scoped>
#login {
  width: 490px;
  margin: auto;
  margin-top: 120px;
  padding: 20px;
}
#languages {
  margin-top: 1em;
}

#languages a {
  padding: 1em;
}

#languages img {
  width: 2.5em;
}
</style>
